import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { JwtService } from 'src/app/core/services/jwt.service';
import { UserService } from 'src/app/core/services/user.service';

@Component({
  selector: 'app-contact-us',
  templateUrl: './contact-us.component.html',
  styleUrls: ['./contact-us.component.css']
})
export class ContactUsComponent implements OnInit {

  workPASStokenExist: boolean = false;
  userToken: any;
  userID: any;
  isProfileComplete: boolean = false;
  userData: any;

  constructor(private router: Router, private jwt: JwtService, private userService: UserService) {}

  ngOnInit(): void {

    this.userData = JSON.parse(localStorage.getItem("applicantDetails"));

    this.userToken = this.jwt.getToken();
    this.jwt.getToken() ? this.workPASStokenExist = true : this.workPASStokenExist = false;
    this.userID = localStorage.getItem("userID");
    this.userService.getApplicantDetails(this.userID).subscribe((res) => {
      this.userData = res;
    },
    () => {
      
    });


  }

  onNavigateLogin() {
    this.router.navigate(["login"]);
  }  

  onNavigateDashboard() {   
    if(this.userData.isProfileComplete == true){
    this.router.navigate(["dashboard"]);
    } else {
      this.router.navigate(["applicant-profilling"]);
    }
  }   
}
